import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import PromotionalBanner from '../PromotionalBanner/PromotionalBanner';
import * as styles from './TopMiniNav.css';

const cx = classNames.bind(styles);

export class TopMiniNav extends Component {
    static propTypes = {
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        enableSitePromo: PropTypes.bool,
        enableAccessibility: PropTypes.bool,
        isNewHeader: PropTypes.bool,
        syndicateSites: PropTypes.array,
        isFragment: PropTypes.bool,
    };

    static defaultProps = {
        deviceType: {},
        enableSitePromo: false,
        enableAccessibility: false,
        isNewHeader: false,
        syndicateSites: [],
        isFragment: false,
    };

    shouldComponentUpdate() {
        return false; // since it's controlled by a 3rd party
    }

    render() {
        const {
            enableSitePromo,
            deviceType,
            enableAccessibility,
            isNewHeader,
            syndicateSites,
            isFragment,
        } = this.props;
        const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '';
        const isSyndicatePage = syndicateSites.some((path) => currentUrl.includes(path));

        const devictTypeClass = deviceType.isDesktop
            ? `${dt([
                  'sm:relative',
                  'sm:z-[8]',
                  'sm:w-full',
                  'sm:bg-white',
                  'sm:text-black',
                  'sm:min-h-[36px]',
              ])} ${'topMiniNavBlackBar'}`
            : `${dt(['sm:relative', 'sm:z-[8]', 'w-full'])} ${'topMiniNavMain'}`;
        const headerClass = isNewHeader ? 'newHeader' : '';
        const disableSitePromoClass =
            !enableSitePromo && `${dt(['sm:top-[2px'])} ${'disableSitePromoView'}`;

        return (
            <div
                id="primaryHeader"
                data-automation-id="sitePromoAccessibleView"
                className={cx(devictTypeClass, headerClass)}
            >
                {enableSitePromo && (
                    <PromotionalBanner isNewHeader deviceType={this.props.deviceType} />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    syndicateSites: get(state, 'context.preferences.syndicateSites', []),
    isFragment: get(state, 'context.isFragment', false),
});

export default connect(mapStateToProps)(TopMiniNav);
